import { Commas } from "../../Common/AllDateTimeReleventFormate";
import SARBadgeIcon from "../../Common/CustomeLabel/SARBadgeIcon";
import ots from "../../../assests/imgs/ots-overview.svg";
import pbp from "../../../assests/imgs/pb-status.svg";
import wbo from "../../../assests/imgs/wbo.svg";
import ptj from "../../../assests/imgs/ptj.svg";
import bsm from "../../../assests/imgs/tai.svg";
import tai from "../../../assests/imgs/tai-icon.svg";
import bsa from "../../../assests/imgs/bsa.svg";


export default function CompanyUserTabs({ data, type = 0 }) {
  return (
    <>
      {type == 1 ? (
        <div className="col-md-4 report-order">
          <div className="report-first">
            <h5>
              <SARBadgeIcon />
              Total Earnings
            </h5>

            <div className="row total-row">
              <div className="col-md-12 total-earning">
                <p>Total Earnings Since Joining</p>
                <h2>SAR {Commas(data?.total_earnings ?? 0)}</h2>
              </div>

              <div className="col-md-12 total-earning border-total">
                <p>Total Earnings From Post & Browse Projects (PBP)</p>
                <h2>SAR {Commas(data?.total_earnings_project ?? 0)}</h2>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="col-md-4 report-order">
          <div className="report-first">
            <h5>
              <SARBadgeIcon />
              Total Spend
            </h5>

            <div className="row total-row">
              <div className="col-md-12 total-earning">
                <p>Total Spend Since Joining</p>
                <h2>SAR {Commas(data?.total_spend ?? 0)}</h2>
              </div>

              <div className="col-md-12 total-earning border-total">
                <p>Total Spend From Post & Browse Projects (PBP)</p>
                <h2>SAR {Commas(data?.total_spend_project ?? 0)}</h2>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ---------------- STATUS CARDS ---------------- */}

      <StatusCard
        title="PBP Status"
        icon={pbp}
        type={type}
        systemData={data?.project}
        userData={data?.project_user}
        labels={[
          ["Pending Request", "pending_project"],
          ["Completed PBP", "completed_project"],
          ["Active PBP", "active_project"],
          ["Total PBP", "total_project"],
          ["Created PBP", "listed_project"],
        ]}
      />

      <StatusCard
        title="WBO Status"
        icon={wbo}
        type={type}
        systemData={data?.contest}
        userData={data?.contest_user}
        labels={[
          ["Pending Request", "pending_contest"],
          ["Completed WBO", "completed_contest"],
          ["Active WBO", "active_contest"],
          ["Total WBO", "total_contest"],
          ["Created WBO", "listed_contest"],
        ]}
      />

      <StatusCard
        title="PTJ Status"
        icon={ptj}
        type={type}
        systemData={data?.job}
        userData={data?.job_user}
        labels={[
          ["Pending Request", "pending_job"],
          ["Completed PTJ", "completed_job"],
          ["Active PTJ", "active_job"],
          ["Total PTJ", "total_job"],
          ["Created PTJ", "listed_job"],
        ]}
      />

      <StatusCard
        title="OTS Status"
        icon={ots}
        type={type}
        systemData={data?.bxp_request}
        userData={data?.bxp_request_user}
        labels={[
          ["Pending Request", "pending_bxp"],
          ["Completed Package Service", "completed_bxp"],
          ["Active Package Service", "active_bxp"],
          ["Total Package Service", "total_bxp"],
          ["Created Package Service", "listed_bxp"],
        ]}
      />

      <StatusCard
        title="BSM Status"
        icon={bsm}
        type={type}
        systemData={data?.sale_request}
        userData={data?.sale_request_user}
        labels={[
          ["Pending Request", "pending_sale"],
          ["Completed Sale", "completed_sale"],
          ["Active Sale", "active_sale"],
          ["Total Sale", "total_sale"],
          ["Created Sale", "listed_sale"],
        ]}
      />

      <StatusCard
        title="TAI Status"
        icon={tai}
        type={type}
        systemData={data?.rental_request}
        userData={data?.rental_request_user}
        labels={[
          ["Pending Request", "pending_rental"],
          ["Completed Rental", "completed_rental"],
          ["Active Rental", "active_rental"],
          ["Total Rental", "total_rental"],
          ["Created Rental", "listed_rental"],
        ]}
      />

      <StatusCard
        title="BSA Status"
        icon={bsa}
        type={type}
        systemData={data?.auction_bid}
        userData={data?.auction_bid_user}
        labels={[
          ["Pending Request", "pending_auction"],
          ["Completed BSA", "completed_auction"],
          ["Active BSA", "active_auction"],
          ["Total BSA", "total_auction"],
          ["Created BSA", "listed_auction"],
        ]}
      />
    </>
  );
}

/* ---------------- REUSABLE STATUS CARD ---------------- */

function StatusCard({
  title,
  icon,
  labels,
  type,
  systemData = {},
  userData = {},
}) {
  const finalData = type == 1 ? systemData : userData;

  return (
    <div className="col-md-4 report-order">
      <div className="report-first">
        <h5>
          <img src={icon} alt="" /> {title}
        </h5>

        <div className="row total-row">
          {labels.filter(([, key]) => {
            if (!key.startsWith("listed_")) return true;

            if (type == 0) {
              return [
                "listed_job",
                "listed_contest",
                "listed_project",
              ].includes(key);
            }

            if (type == 1) {
              return [
                "listed_bxp",
                "listed_sale",
                "listed_rental",
                "listed_auction",
              ].includes(key);
            }

            return false;
          })
            .map(([label, key], index) => (
              <div
                key={key}
                className={`col-md-6 total-earning
                  ${index >= 2 ? "border-total" : ""}
                  ${index % 2 !== 0 ? "earning-right" : ""}`}
              >
                <p>{label}</p>
                <h2>{finalData?.[key] ?? 0}</h2>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
}
